import type { SVGProps } from 'react';

export const PocketCastsLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="-5 -5 42 42" {...props}>
    <title>Pocket Casts</title>
    <rect x="-5" y="-5" width="42" height="42" fill="#f43e37" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="white"
      d="M16 3.556C9.127 3.556 3.556 9.127 3.556 16c0 6.873 5.571 12.444 12.444 12.444v-3.11A9.333 9.333 0 1 1 25.333 16h3.111c0-6.874-5.571-12.445-12.444-12.445ZM8.533 16A7.467 7.467 0 0 0 16 23.467v-2.715A4.751 4.751 0 1 1 20.752 16h2.715a7.467 7.467 0 0 0-14.934 0Z"
    />
  </svg>
);
